import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './Countdown';
export function UrgencySection() {
  return <section aria-labelledby="urgencia-title" className="border-b border-line bg-ink" data-id="element-296" data-mp="2sk43xcq97k7c">
      <div className="mx-auto grid max-w-content gap-8 px-5 py-12 sm:px-8 lg:grid-cols-2 lg:items-center lg:py-16" style={{
      paddingBottom: "14px"
    }} data-id="element-297" data-mp="36ar479bnxi5j">
        <div className="flex flex-col items-center text-center" data-id="element-298" data-mp="3g85869gegegy">
          <h2 id="urgencia-title" className="text-xs font-bold uppercase tracking-[0.2em] text-accent sm:text-sm" style={{
          fontSize: "10px",
          fontWeight: "800"
        }} data-id="element-299" data-mp="3g6alaplkica8">
            Precio de lanzamiento — cierra en
          </h2>
          <div className="mt-5" data-id="element-300" data-mp="3l7ht2onpnbgw">
            <Countdown size="lg" data-id="element-301" data-mp="3l89r064s5lac" />
          </div>
          <p className="mt-6 inline-flex items-center justify-center gap-2 rounded-lg border border-danger/40 bg-danger/10 px-4 py-2.5 text-[10px] font-semibold text-danger" data-id="element-302" data-mp="3l5dtuk0rb0my">
            <AlertTriangleIcon aria-hidden="true" className="h-4 w-4 shrink-0" data-id="element-303" data-mp="1qv0b9wln53jn" />
            Después sube $8.000 ARS. No vuelve.
          </p>
        </div>

        <div className="w-full rounded-2xl border border-line bg-surface px-5 pb-4 pt-3" data-id="element-304" data-mp="2xrzjs5a97fx7">
          <div className="flex flex-wrap items-center justify-between gap-2" data-id="element-305" data-mp="32rc68ox7qkz9">
            <p className="text-sm font-bold text-danger" style={{
            fontSize: "9px",
            fontWeight: "500"
          }} data-id="element-306" data-mp="37ikdpfezfw9s">Cupos al precio de lanzamiento</p>
            <p className="text-sm font-bold text-ivory" style={{
            fontSize: "9px",
            fontWeight: "500"
          }} data-id="element-307" data-mp="3ch40tj5bbe3q">Quedan pocos</p>
          </div>
          <div className="mt-4 h-2.5 w-full overflow-hidden rounded-full bg-surfaceAlt" role="progressbar" aria-valuenow={68} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos tomados al precio de lanzamiento" data-id="element-308" data-mp="3lhtvgjiu6yfv">
            <div className="h-full rounded-full bg-danger" style={{
            width: '68%'
          }} data-id="element-309" data-mp="1r5ceftolcujo" />
          </div>
          <p className="mt-3 text-center text-sm text-muted" style={{
          fontSize: "8px",
          textAlign: "right"
        }} data-id="element-310" data-mp="1w46vor6wub1o">
            <span className="font-bold text-ivory" data-id="element-311" data-mp="1o4sh8mzll0zj">68%</span> de los cupos al precio de lanzamiento
            ya fueron tomados.
          </p>
        </div>
      </div>
    </section>;
}